import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, of, tap } from 'rxjs';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { MailOrderFamilyMember } from 'src/app/interfaces/mail-order-profile.interface';
import { Member } from 'src/app/interfaces/member.interface';
import { AppCenterAnalytics } from 'src/app/services/app-insights/app-insights';
import { AppInsightsService } from 'src/app/services/app-insights/app-insights.service';
import { MailOrderProfileEnrollmentService } from 'src/app/services/mail-order-profile-enrollment/mail-order-profile-enrollment.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-update-mail-order-profile-dialog',
  templateUrl: './update-mail-order-profile-dialog.component.html',
  styleUrls: ['./update-mail-order-profile-dialog.component.scss']
})
export class UpdateMailOrderProfileDialogComponent implements OnInit {

  membersDetails$!: Observable<MailOrderFamilyMember[]>;
  selectedMember: MailOrderFamilyMember | null = null;
  action: 'update-now' | 'update-later' | null = null;

  constructor(
    public readonly mailOrderService: MailOrderProfileEnrollmentService,
    public readonly userService: UserService,
    private readonly appInsightsService: AppInsightsService,
    public multilingualService: MultilingualService,
    private readonly dialogRef: MatDialogRef<UpdateMailOrderProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { loadMembersByPHI: boolean, member: Member }
  ) { }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.UPDATE_PATIENT_ENROLLMENT_DIALOG_VIEWED);

    if (this.data.loadMembersByPHI) {
      // Get logged in member
      const personCode = this.userService.eligibilityVerificationResponse?.personCode;

      this.membersDetails$ = this.mailOrderService.getMembersToUpdateProfile().pipe(
        map((members) => {
          return members.filter(x => !x.enrolledInPharmacySystem);
        }),
        tap((members) => {
          const loggedInMember = members.find(x => x.memberProfile.personCode === personCode);
          if (loggedInMember) {
            this.selectedMember = loggedInMember;
          }
        }));
    } else {
      const memberDetail = {
        memberProfile: this.data.member,
        enrolledInPharmacySystem: false
      };
      this.membersDetails$ = of([memberDetail])
      this.selectedMember = memberDetail;
    }
  }

  close(action: 'update-now' | 'update-later' | null = null) {
    if (action === 'update-now') {
      const result = {
        action: 'update-now',
        selectedMember: this.selectedMember
      }
      this.dialogRef.close(result);
    } else {
      this.dialogRef.close({ action: 'update-later' });
    }
  }
}
